// src/components/SortTh.jsx
// Sortable table headers (3.16.0), as in Users → People: click a header to
// sort by it, again to reverse. useSort(rows, accessors, initial) returns
// { sorted, sort, onSort }; <SortTh k="date" label="Date" sort onSort style />.
// Sorting is on the rows shown (what the filters and "Show" loaded).
import { useMemo, useState } from 'react';

export function useSort(rows, accessors, initial = null) {
  const [sort, setSort] = useState(initial);   // { key, dir: 1 | -1 } or null = as loaded
  const onSort = key => setSort(s => (s?.key === key ? { key, dir: -s.dir } : { key, dir: 1 }));
  const sorted = useMemo(() => {
    const get = sort && accessors[sort.key];
    if (!get) return rows;
    const val = r => { const v = get(r); return v == null ? '' : typeof v === 'string' ? v.toLowerCase() : v; };
    return [...rows].sort((a, b) => {
      const x = val(a), y = val(b);
      if (x === y) return 0;
      if (x === '') return 1;   // empty values last either way
      if (y === '') return -1;
      return (x < y ? -1 : 1) * sort.dir;
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows, sort]);
  return { sorted, sort, onSort };
}

export default function SortTh({ k, label, sort, onSort, style, children }) {
  const on = sort?.key === k;
  return (
    <th style={style} aria-sort={on ? (sort.dir > 0 ? 'ascending' : 'descending') : 'none'}>
      <button type="button" onClick={() => onSort(k)} title={`Sort by ${label}`}
        style={{ background: 'none', border: 'none', padding: 0, margin: 0, color: 'inherit', font: 'inherit', textTransform: 'inherit', letterSpacing: 'inherit', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {children || label}
        <span aria-hidden="true" style={{ opacity: on ? 1 : 0.35, fontSize: 10 }}>{on ? (sort.dir > 0 ? '▲' : '▼') : '↕'}</span>
      </button>
    </th>
  );
}
